import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1011 999">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="">
          <path
            fill="#000000"
            opacity="1.000000"
            stroke="none"
            d="
M544.000000,1000.000000 
	C362.666656,1000.000000 181.833328,1000.000000 1.000000,1000.000000 
	C1.000000,667.000000 1.000000,334.000000 1.000000,1.000000 
	C338.000000,1.000000 675.000000,1.000000 1012.000000,1.000000 
	C1012.000000,334.000000 1012.000000,667.000000 1012.000000,1000.000000 
	C856.166687,1000.000000 700.333313,1000.000000 544.000000,1000.000000 
M758.371704,80.032623 
	C750.503662,75.681229 742.821899,70.940895 734.726868,67.063438 
	C720.117371,60.065628 705.526672,52.895252 690.437561,47.067059 
	C672.978821,40.323616 655.231262,34.049133 637.166565,29.229801 
	C618.038330,24.126732 598.471802,20.498613 578.941223,17.127041 
	C564.664795,14.662501 550.154602,12.480671 535.716797,12.260124 
	C510.727997,11.878406 485.652832,10.540788 460.716827,13.975041 
	C445.249786,16.105204 429.543732,17.029675 414.319122,20.259197 
	C394.232849,24.520002 374.313843,29.868034 354.700806,35.964359 
	C339.596832,40.659138 324.725708,46.476700 310.381073,53.149410 
	C291.047913,62.142651 271.842987,71.625061 253.476318,82.417770 
	C237.517303,91.795662 222.483139,102.863251 207.632690,113.975868 
	C195.367020,123.154312 183.463440,132.953003 172.295273,143.431671 
	C152.587891,161.922379 134.409149,181.850113 117.921608,203.372452 
	C100.603561,225.978897 85.307678,249.830978 72.155609,274.996948 
	C64.589584,289.474274 57.843224,304.471344 51.949177,319.706909 
	C45.253765,337.013977 39.384850,354.690125 34.134945,372.494293 
	C27.828033,393.883179 23.129131,415.687439 20.957798,437.959595 
	C19.705868,450.801147 17.460337,463.612335 17.197723,476.468567 
	C16.784397,496.702911 17.511005,516.968018 18.069916,537.211365 
	C18.318733,546.223389 18.687233,555.320068 20.138645,564.192322 
	C23.005825,581.718994 26.342180,599.185364 30.065102,616.552185 
	C37.395855,650.749023 49.614788,683.323730 64.511238,714.857178 
	C75.385040,737.875183 88.497513,759.637817 102.828819,780.739990 
	C116.127243,800.321106 130.766342,818.797546 146.838806,836.029297 
	C159.347504,849.440308 173.148407,861.672180 186.678680,874.097412 
	C202.848053,888.946289 220.673096,901.627441 239.030975,913.664246 
	C264.118805,930.113831 290.425690,944.103088 318.109985,955.627686 
	C343.795197,966.320129 370.089752,975.096130 397.288361,980.906311 
	C412.300140,984.113220 427.471741,986.673645 442.661499,988.913574 
	C455.088287,990.746094 467.637634,992.659973 480.152100,992.799927 
	C508.252472,993.114441 536.426880,994.317810 564.405457,990.033752 
	C576.610168,988.164917 589.054382,987.475342 601.060608,984.782227 
	C620.799927,980.354553 640.484009,975.414368 659.787476,969.395142 
	C675.037903,964.639893 690.009644,958.647095 704.513489,951.926941 
	C723.719543,943.028076 742.849548,933.736206 761.075806,923.020508 
	C777.170593,913.557983 792.281311,902.312500 807.264343,891.102783 
	C819.398926,882.024109 831.210938,872.375183 842.254883,862.008545 
	C862.079224,843.400024 880.427185,823.401184 896.981873,801.714355 
	C914.352417,778.958618 929.881653,755.081970 942.905579,729.650024 
	C950.283142,715.243835 957.115234,700.474792 962.970642,685.394653 
	C969.687378,668.096008 975.627197,650.441101 980.854187,632.632690 
	C987.132812,611.241699 991.891541,589.443542 994.024109,567.168762 
	C995.348633,553.334351 997.484070,539.518799 997.804932,525.661194 
	C998.250244,506.429474 997.493408,487.161591 996.931458,467.918518 
	C996.663391,458.739685 996.315613,449.475525 994.846497,440.438141 
	C991.997131,422.909485 988.716858,405.429077 984.918945,388.081055 
	C977.477905,354.092529 965.328857,321.665924 950.580261,290.241516 
	C939.557800,266.756378 926.752441,244.146286 911.424316,223.234406 
	C897.585205,204.353958 883.085083,185.838547 867.508057,168.383331 
	C850.164856,148.949097 831.053040,131.075485 809.969727,115.642563 
	C793.317078,103.452904 776.004089,92.165367 758.371704,80.032623 
z"
          />
          <path
            fill="#FEFFFF"
            opacity="1.000000"
            stroke="none"
            d="
M758.678040,80.254898 
	C776.004089,92.165367 793.317078,103.452904 809.969727,115.642563 
	C831.053040,131.075485 850.164856,148.949097 867.508057,168.383331 
	C883.085083,185.838547 897.585205,204.353958 911.424316,223.234406 
	C926.752441,244.146286 939.557800,266.756378 950.580261,290.241516 
	C965.328857,321.665924 977.477905,354.092529 984.918945,388.081055 
	C988.716858,405.429077 991.997131,422.909485 994.846497,440.438141 
	C996.315613,449.475525 996.663391,458.739685 996.931458,467.918518 
	C997.493408,487.161591 998.250244,506.429474 997.804932,525.661194 
	C997.484070,539.518799 995.348633,553.334351 994.024109,567.168762 
	C991.891541,589.443542 987.132812,611.241699 980.854187,632.632690 
	C975.627197,650.441101 969.687378,668.096008 962.970642,685.394653 
	C957.115234,700.474792 950.283142,715.243835 942.905579,729.650024 
	C929.881653,755.081970 914.352417,778.958618 896.981873,801.714355 
	C880.427185,823.401184 862.079224,843.400024 842.254883,862.008545 
	C831.210938,872.375183 819.398926,882.024109 807.264343,891.102783 
	C792.281311,902.312500 777.170593,913.557983 761.075806,923.020508 
	C742.849548,933.736206 723.719543,943.028076 704.513489,951.926941 
	C690.009644,958.647095 675.037903,964.639893 659.787476,969.395142 
	C640.484009,975.414368 620.799927,980.354553 601.060608,984.782227 
	C589.054382,987.475342 576.610168,988.164917 564.405457,990.033752 
	C536.426880,994.317810 508.252472,993.114441 480.152100,992.799927 
	C467.637634,992.659973 455.088287,990.746094 442.661499,988.913574 
	C427.471741,986.673645 412.300140,984.113220 397.288361,980.906311 
	C370.089752,975.096130 343.795197,966.320129 318.109985,955.627686 
	C290.425690,944.103088 264.118805,930.113831 239.030975,913.664246 
	C220.673096,901.627441 202.848053,888.946289 186.678680,874.097412 
	C173.148407,861.672180 159.347504,849.440308 146.838806,836.029297 
	C130.766342,818.797546 116.127243,800.321106 102.828819,780.739990 
	C88.497513,759.637817 75.385040,737.875183 64.511238,714.857178 
	C49.614788,683.323730 37.395855,650.749023 30.065102,616.552185 
	C26.342180,599.185364 23.005825,581.718994 20.138645,564.192322 
	C18.687233,555.320068 18.318733,546.223389 18.069916,537.211365 
	C17.511005,516.968018 16.784397,496.702911 17.197723,476.468567 
	C17.460337,463.612335 19.705868,450.801147 20.957798,437.959595 
	C23.129131,415.687439 27.828033,393.883179 34.134945,372.494293 
	C39.384850,354.690125 45.253765,337.013977 51.949177,319.706909 
	C57.843224,304.471344 64.589584,289.474274 72.155609,274.996948 
	C85.307678,249.830978 100.603561,225.978897 117.921608,203.372452 
	C134.409149,181.850113 152.587891,161.922379 172.295273,143.431671 
	C183.463440,132.953003 195.367020,123.154312 207.632690,113.975868 
	C222.483139,102.863251 237.517303,91.795662 253.476318,82.417770 
	C271.842987,71.625061 291.047913,62.142651 310.381073,53.149410 
	C324.725708,46.476700 339.596832,40.659138 354.700806,35.964359 
	C374.313843,29.868034 394.232849,24.520002 414.319122,20.259197 
	C429.543732,17.029675 445.249786,16.105204 460.716827,13.975041 
	C485.652832,10.540788 510.727997,11.878406 535.716797,12.260124 
	C550.154602,12.480671 564.664795,14.662501 578.941223,17.127041 
	C598.471802,20.498613 618.038330,24.126732 637.166565,29.229801 
	C655.231262,34.049133 672.978821,40.323616 690.437561,47.067059 
	C705.526672,52.895252 720.117371,60.065628 734.726868,67.063438 
	C742.821899,70.940895 750.503662,75.681229 758.678040,80.254898 
M739.455994,369.948090 
	C746.298645,360.297485 753.141357,350.646881 760.611755,340.110931 
	C757.538330,340.110931 755.890198,340.114075 754.242126,340.110474 
	C721.914307,340.039642 689.585999,340.046936 657.258728,339.873749 
	C626.438965,339.708649 595.619873,339.385132 564.801453,339.042206 
	C561.393555,339.004303 559.349060,340.372406 557.559204,343.217712 
	C541.604004,368.581696 525.539673,393.877106 509.475464,419.172363 
	C505.517181,425.405304 501.441559,431.563721 496.920624,438.525238 
	C495.398224,436.378815 494.412781,435.117340 493.561768,433.770905 
	C474.708679,403.941650 455.787628,374.154572 437.130127,344.203369 
	C434.691498,340.288605 432.112671,338.931610 427.564087,338.957184 
	C365.587769,339.306152 303.610321,339.458221 241.633179,339.657074 
	C238.880661,339.665894 236.128098,339.658203 233.269028,339.658203 
	C233.418930,340.716003 233.358841,341.102173 233.521759,341.326172 
	C250.168472,364.216949 266.776947,387.136230 283.608795,409.890289 
	C284.833374,411.545715 287.641479,412.737427 289.791443,412.868958 
	C296.433350,413.275330 303.139008,413.435669 309.769897,412.973877 
	C315.006470,412.609192 316.118530,414.437134 316.078949,419.422211 
	C315.609314,478.571045 315.485474,537.722839 314.906708,596.870361 
	C314.843872,603.293152 316.914459,607.791565 321.024231,612.303467 
	C353.766876,648.249329 386.366058,684.325867 419.026550,720.346680 
	C419.932770,721.346130 421.032349,722.170227 422.376465,723.376526 
	C422.691223,722.159912 422.908203,721.711487 422.908905,721.262695 
	C422.963379,687.268799 423.042023,653.274719 422.929565,619.281311 
	C422.923340,617.394958 421.710144,615.174622 420.402405,613.686523 
	C413.039520,605.308105 405.577301,597.010498 397.926941,588.894592 
	C395.115173,585.911743 393.883209,582.905762 393.980408,578.702271 
	C394.392395,560.882874 394.471008,543.054749 394.570374,525.229248 
	C394.764496,490.402710 394.887451,455.575745 395.058014,420.749084 
	C395.064880,419.348907 395.256927,417.949615 395.362671,416.549927 
	C395.759552,416.371490 396.156403,416.193054 396.553284,416.014618 
	C429.947571,458.068726 463.341827,500.122833 497.071930,542.599854 
	C530.984070,499.997009 564.309814,458.130768 597.635559,416.264557 
	C598.140869,416.541687 598.646240,416.818817 599.151550,417.095947 
	C599.151550,419.374268 599.166870,421.652740 599.149170,423.930908 
	C598.870361,459.912689 598.567566,495.894257 598.314026,531.876221 
	C598.197754,548.372803 598.267029,564.871460 598.004700,581.365234 
	C597.969177,583.597107 597.005127,586.236145 595.584595,587.953491 
	C588.050476,597.061646 580.122192,605.844116 572.606934,614.967102 
	C571.086121,616.813171 569.974609,619.645630 569.993469,622.012878 
	C570.254639,654.830872 570.741943,687.647217 571.198242,720.463562 
	C571.214905,721.662598 571.479919,722.858276 571.740845,724.950745 
	C573.532837,723.054810 574.680786,721.907227 575.754333,720.693909 
	C586.127014,708.971863 596.468994,697.222534 606.854858,685.512085 
	C629.836060,659.599670 652.864624,633.729126 675.765381,607.745911 
	C677.184998,606.135254 678.440735,603.702026 678.459106,601.639771 
	C678.637207,581.645325 678.545471,561.648376 678.509216,541.652100 
	C678.434021,500.160919 678.367371,458.669617 678.217834,417.178680 
	C678.206970,414.168518 679.204712,413.005676 682.255493,413.062134 
	C689.418396,413.194763 696.592346,412.906525 703.748291,413.164368 
	C707.300598,413.292419 709.462524,412.207520 711.537598,409.206085 
	C720.532776,396.195465 729.838684,383.399628 739.455994,369.948090 
M419.500000,295.972260 
	C430.664612,295.969910 441.832306,296.115448 452.992126,295.883423 
	C456.798920,295.804260 457.802582,297.067169 457.772919,300.751190 
	C457.657532,315.080200 457.725220,329.414459 458.037689,343.739929 
	C458.098999,346.552490 458.974152,349.694794 460.457428,352.071167 
	C468.567108,365.063904 476.983185,377.865417 485.294983,390.731995 
	C489.042419,396.532898 492.792419,402.332184 496.791046,408.518768 
	C497.841766,407.421173 498.488556,406.933746 498.894928,406.293640 
	C510.673828,387.739441 522.479614,369.201691 534.107483,350.553070 
	C535.252441,348.716766 535.721863,346.192566 535.758484,343.975281 
	C535.987000,330.146942 536.004639,316.315094 536.087708,302.484406 
	C536.100281,300.385864 536.089478,298.287170 536.089478,295.670898 
	C539.635803,295.670898 542.438965,295.668304 545.242126,295.671265 
	C625.065063,295.754883 704.888062,295.818115 784.710815,295.988312 
	C788.511597,295.996399 790.989380,295.169861 793.331970,291.752655 
	C806.601929,272.395203 820.221069,253.277222 833.699036,234.062088 
	C836.228088,230.456604 838.656311,226.780426 841.280945,222.916138 
	C611.210815,222.916138 381.782318,222.916138 151.357117,222.916138 
	C153.031387,225.478012 154.038040,227.145279 155.166382,228.725632 
	C169.770645,249.180405 184.570877,269.499146 198.873581,290.162354 
	C202.118805,294.850739 205.453857,296.452393 211.032333,296.428467 
	C280.187592,296.131744 349.343933,296.084106 419.500000,295.972260 
M532.981140,524.470825 
	C521.346558,538.950928 509.712036,553.431030 497.781799,568.279236 
	C484.438904,552.170654 471.606537,536.678345 458.224884,520.522949 
	C458.002258,522.206848 457.883453,522.685120 457.883636,523.163391 
	C457.911804,589.109924 457.981384,655.056519 457.904999,721.002869 
	C457.900330,725.032776 458.836121,726.470398 463.125732,726.405945 
	C486.269012,726.057983 509.416840,726.014832 532.562927,725.840027 
	C533.673523,725.831665 534.782349,725.572754 536.000854,725.416565 
	C536.109741,724.178162 536.272766,723.203552 536.269958,722.229553 
	C536.131653,674.603210 535.993286,626.976868 535.820801,579.350647 
	C535.756897,561.709167 535.637939,544.067566 535.410461,526.427734 
	C535.399475,525.572510 534.098083,524.734009 532.981140,524.470825 
M685.702271,822.500000 
	C685.710022,810.339172 685.569580,798.175415 685.812866,786.019348 
	C685.889160,782.205811 684.668518,781.175964 680.981018,781.228760 
	C667.490417,781.421936 653.995422,781.325317 640.502136,781.307495 
	C638.745239,781.305176 636.988586,781.125916 635.247192,781.029480 
	C635.247192,776.249329 635.247192,772.040588 635.247192,767.868286 
	C640.447449,767.868286 645.208130,767.868286 650.167969,767.868286 
	C650.404053,770.727783 650.616028,773.295959 650.852356,776.158569 
	C661.791748,776.158569 672.266418,776.254211 682.732971,776.007385 
	C683.756470,775.983276 685.527405,773.892456 685.591064,772.688965 
	C685.889954,767.041260 685.730835,761.368408 685.702393,755.704590 
	C685.649109,745.083618 680.392944,739.838318 669.680237,739.820923 
	C647.857849,739.785522 626.034424,739.896667 604.213562,739.708679 
	C600.140686,739.673645 599.219055,741.044922 599.252441,744.893921 
	C599.424377,764.715881 599.402466,784.540894 599.237549,804.363159 
	C599.205444,808.227417 600.291992,809.652832 604.319214,809.590576 
	C617.809387,809.382141 631.304688,809.498901 644.798035,809.517578 
	C646.558777,809.520020 648.319275,809.676270 650.066711,809.760681 
	C650.066711,815.543396 650.066711,820.763306 650.066711,825.884033 
	C644.782166,825.884033 639.918518,825.884033 634.833008,825.884033 
	C634.833008,823.914917 634.669678,822.404236 634.862976,820.940613 
	C635.496643,816.142456 633.647034,814.515991 628.723450,814.760925 
	C620.581482,815.166138 612.399231,815.013977 604.243469,814.773560 
	C600.579590,814.665466 599.207520,815.786072 599.252075,819.553223 
	C599.417542,833.544006 599.319885,847.537842 599.374512,861.530273 
	C599.378662,862.587708 599.802490,863.643494 600.136841,865.188232 
	C612.118530,861.386902 623.765015,858.009888 635.162720,853.936584 
	C640.554749,852.009583 645.329712,852.277405 650.580566,854.077026 
	C661.864441,857.944458 673.287476,861.405701 685.702026,865.367859 
	C685.702026,850.953552 685.702026,837.226746 685.702271,822.500000 
M316.082947,772.500000 
	C316.073242,782.998840 316.284912,793.504761 315.951233,803.993347 
	C315.805939,808.560852 317.430298,809.649170 321.705200,809.561951 
	C333.532166,809.320679 345.367615,809.495667 357.199707,809.504944 
	C360.311157,809.507385 363.422638,809.505371 366.835999,809.505371 
	C366.835999,815.386169 366.835999,820.606934 366.835999,825.944580 
	C361.622803,825.944580 356.755707,825.944580 351.549438,825.944580 
	C351.549438,823.853333 351.337250,822.164917 351.589203,820.548889 
	C352.347382,815.685120 350.082916,814.616394 345.638885,814.785461 
	C337.485077,815.095642 329.305939,815.031189 321.147034,814.792603 
	C317.215668,814.677673 315.939423,815.989502 315.998901,819.951477 
	C316.201599,833.446899 316.050201,846.947571 316.083771,860.446045 
	C316.087219,861.832886 316.424835,863.218933 316.684875,865.193909 
	C329.691101,861.080933 341.971252,856.990967 354.398621,853.412476 
	C357.517059,852.514526 361.327789,852.492737 364.442627,853.385803 
	C375.478088,856.549500 386.347168,860.292297 397.285126,863.797485 
	C402.328461,865.413696 402.621765,865.208496 402.627747,859.823425 
	C402.655121,835.159485 402.591309,810.495056 402.749268,785.832031 
	C402.772247,782.244385 401.587738,781.224792 398.154510,781.257507 
	C384.157410,781.390991 370.158173,781.315491 356.159821,781.286865 
	C354.748505,781.283997 353.337585,781.078064 351.750519,780.952515 
	C351.584717,777.326904 351.251068,774.176819 351.395264,771.048767 
	C351.449463,769.873291 352.549286,767.804688 353.280731,767.755493 
	C357.833649,767.449707 362.417297,767.601379 366.877655,767.601379 
	C367.496796,776.138733 367.496796,776.136475 375.077820,776.138123 
	C382.743683,776.139832 390.416687,775.953918 398.072327,776.235657 
	C401.695038,776.369080 402.789246,775.060669 402.687134,771.664612 
	C402.521912,766.170044 402.699036,760.666138 402.619354,755.167847 
	C402.479584,745.526672 397.072083,739.932678 387.362274,739.875610 
	C365.032013,739.744263 342.699982,739.898682 320.369873,739.751770 
	C316.658783,739.727417 315.950958,741.205200 316.018585,744.504028 
	C316.202942,753.499329 316.082611,762.500916 316.082947,772.500000 
M520.503906,739.998413 
	C515.423950,739.998413 510.343994,739.998413 505.439270,739.998413 
	C505.439270,782.224121 505.439270,823.537598 505.439270,865.376587 
	C514.258057,862.577942 522.778381,860.675781 530.602112,857.203857 
	C542.442932,851.949280 553.627075,851.945251 565.490417,857.089050 
	C573.473633,860.550537 582.096802,862.536255 590.591125,865.232239 
	C590.898132,863.986511 591.188782,863.355530 591.189453,862.724304 
	C591.206909,845.906616 591.265869,829.088074 591.078857,812.272400 
	C591.059753,810.555237 589.880310,808.530151 588.641785,807.207458 
	C584.932434,803.246155 580.926453,799.562561 576.790161,795.530701 
	C580.796265,791.697327 584.644775,788.474487 587.883728,784.725098 
	C589.550781,782.795410 590.925293,779.969055 591.055054,777.476135 
	C591.444275,770.004578 591.194946,762.497375 591.121338,755.004761 
	C591.024902,745.201111 585.878357,740.061340 575.952698,740.024719 
	C557.802734,739.957703 539.652405,740.001038 520.503906,739.998413 
M496.904480,857.361328 
	C496.894165,823.199341 496.903259,789.037292 496.860931,754.875305 
	C496.849182,745.400269 491.593323,740.074280 482.077698,739.849304 
	C477.081177,739.731140 472.061615,740.088623 467.085815,739.746399 
	C462.898560,739.458435 461.722198,740.878784 461.752686,745.052124 
	C461.935394,770.047424 461.841949,795.044739 461.841125,820.041382 
	C461.841064,821.982666 461.841064,823.924011 461.841064,826.367615 
	C457.848633,826.367615 454.515381,826.071350 451.257202,826.439575 
	C446.772827,826.946350 445.656982,825.265625 445.692200,820.885376 
	C445.895752,795.557129 445.709229,770.225769 445.875397,744.896973 
	C445.900909,741.013550 444.957794,739.460449 440.892273,739.727295 
	C436.079712,740.043030 431.231598,739.796814 426.399139,739.832886 
	C415.781891,739.912231 410.409332,745.809326 410.429321,756.431519 
	C410.494568,791.080444 410.332367,825.729919 410.308044,860.379150 
	C410.306976,861.911133 410.801880,863.443481 411.103516,865.194946 
	C424.562897,860.958252 437.364960,856.802551 450.266205,852.981750 
	C452.631531,852.281311 455.572968,852.362671 457.952850,853.073181 
	C469.118164,856.406616 480.176056,860.098938 491.283691,863.627319 
	C492.922974,864.147949 494.623322,864.476562 496.905029,865.046204 
	C496.905029,862.244202 496.905029,860.277893 496.904480,857.361328 
z"
          />
          <path
            fill="#02D2B3"
            opacity="1.000000"
            stroke="none"
            d="
M739.243774,370.236908 
	C729.838684,383.399628 720.532776,396.195465 711.537598,409.206085 
	C709.462524,412.207520 707.300598,413.292419 703.748291,413.164368 
	C696.592346,412.906525 689.418396,413.194763 682.255493,413.062134 
	C679.204712,413.005676 678.206970,414.168518 678.217834,417.178680 
	C678.367371,458.669617 678.434021,500.160919 678.509216,541.652100 
	C678.545471,561.648376 678.637207,581.645325 678.459106,601.639771 
	C678.440735,603.702026 677.184998,606.135254 675.765381,607.745911 
	C652.864624,633.729126 629.836060,659.599670 606.854858,685.512085 
	C596.468994,697.222534 586.127014,708.971863 575.754333,720.693909 
	C574.680786,721.907227 573.532837,723.054810 571.740845,724.950745 
	C571.479919,722.858276 571.214905,721.662598 571.198242,720.463562 
	C570.741943,687.647217 570.254639,654.830872 569.993469,622.012878 
	C569.974609,619.645630 571.086121,616.813171 572.606934,614.967102 
	C580.122192,605.844116 588.050476,597.061646 595.584595,587.953491 
	C597.005127,586.236145 597.969177,583.597107 598.004700,581.365234 
	C598.267029,564.871460 598.197754,548.372803 598.314026,531.876221 
	C598.567566,495.894257 598.870361,459.912689 599.149170,423.930908 
	C599.166870,421.652740 599.151550,419.374268 599.151550,417.095947 
	C598.646240,416.818817 598.140869,416.541687 597.635559,416.264557 
	C564.309814,458.130768 530.984070,499.997009 497.071930,542.599854 
	C463.341827,500.122833 429.947571,458.068726 396.553284,416.014618 
	C396.156403,416.193054 395.759552,416.371490 395.362671,416.549927 
	C395.256927,417.949615 395.064880,419.348907 395.058014,420.749084 
	C394.887451,455.575745 394.764496,490.402710 394.570374,525.229248 
	C394.471008,543.054749 394.392395,560.882874 393.980408,578.702271 
	C393.883209,582.905762 395.115173,585.911743 397.926941,588.894592 
	C405.577301,597.010498 413.039520,605.308105 420.402405,613.686523 
	C421.710144,615.174622 422.923340,617.394958 422.929565,619.281311 
	C423.042023,653.274719 422.963379,687.268799 422.908905,721.262695 
	C422.908203,721.711487 422.691223,722.159912 422.376465,723.376526 
	C421.032349,722.170227 419.932770,721.346130 419.026550,720.346680 
	C386.366058,684.325867 353.766876,648.249329 321.024231,612.303467 
	C316.914459,607.791565 314.843872,603.293152 314.906708,596.870361 
	C315.485474,537.722839 315.609314,478.571045 316.078949,419.422211 
	C316.118530,414.437134 315.006470,412.609192 309.769897,412.973877 
	C303.139008,413.435669 296.433350,413.275330 289.791443,412.868958 
	C287.641479,412.737427 284.833374,411.545715 283.608795,409.890289 
	C266.776947,387.136230 250.168472,364.216949 233.521759,341.326172 
	C233.358841,341.102173 233.418930,340.716003 233.269028,339.658203 
	C236.128098,339.658203 238.880661,339.665894 241.633179,339.657074 
	C303.610321,339.458221 365.587769,339.306152 427.564087,338.957184 
	C432.112671,338.931610 434.691498,340.288605 437.130127,344.203369 
	C455.787628,374.154572 474.708679,403.941650 493.561768,433.770905 
	C494.412781,435.117340 495.398224,436.378815 496.920624,438.525238 
	C501.441559,431.563721 505.517181,425.405304 509.475464,419.172363 
	C525.539673,393.877106 541.604004,368.581696 557.559204,343.217712 
	C559.349060,340.372406 561.393555,339.004303 564.801453,339.042206 
	C595.619873,339.385132 626.438965,339.708649 657.258728,339.873749 
	C689.585999,340.046936 721.914307,340.039642 754.242126,340.110474 
	C755.890198,340.114075 757.538330,340.110931 760.611755,340.110931 
	C753.141357,350.646881 746.298645,360.297485 739.243774,370.236908 
z"
          />
          <path
            fill="#02D2B4"
            opacity="1.000000"
            stroke="none"
            d="
M419.000000,295.972290 
	C349.343933,296.084106 280.187592,296.131744 211.032333,296.428467 
	C205.453857,296.452393 202.118805,294.850739 198.873581,290.162354 
	C184.570877,269.499146 169.770645,249.180405 155.166382,228.725632 
	C154.038040,227.145279 153.031387,225.478012 151.357117,222.916138 
	C381.782318,222.916138 611.210815,222.916138 841.280945,222.916138 
	C838.656311,226.780426 836.228088,230.456604 833.699036,234.062088 
	C820.221069,253.277222 806.601929,272.395203 793.331970,291.752655 
	C790.989380,295.169861 788.511597,295.996399 784.710815,295.988312 
	C704.888062,295.818115 625.065063,295.754883 545.242126,295.671265 
	C542.438965,295.668304 539.635803,295.670898 536.089478,295.670898 
	C536.089478,298.287170 536.100281,300.385864 536.087708,302.484406 
	C536.004639,316.315094 535.987000,330.146942 535.758484,343.975281 
	C535.721863,346.192566 535.252441,348.716766 534.107483,350.553070 
	C522.479614,369.201691 510.673828,387.739441 498.894928,406.293640 
	C498.488556,406.933746 497.841766,407.421173 496.791046,408.518768 
	C492.792419,402.332184 489.042419,396.532898 485.294983,390.731995 
	C476.983185,377.865417 468.567108,365.063904 460.457428,352.071167 
	C458.974152,349.694794 458.098999,346.552490 458.037689,343.739929 
	C457.725220,329.414459 457.657532,315.080200 457.772919,300.751190 
	C457.802582,297.067169 456.798920,295.804260 452.992126,295.883423 
	C441.832306,296.115448 430.664612,295.969910 419.000000,295.972290 
z"
          />
          <path
            fill="#02D2B4"
            opacity="1.000000"
            stroke="none"
            d="
M533.189392,524.179260 
	C534.098083,524.734009 535.399475,525.572510 535.410461,526.427734 
	C535.637939,544.067566 535.756897,561.709167 535.820801,579.350647 
	C535.993286,626.976868 536.131653,674.603210 536.269958,722.229553 
	C536.272766,723.203552 536.109741,724.178162 536.000854,725.416565 
	C534.782349,725.572754 533.673523,725.831665 532.562927,725.840027 
	C509.416840,726.014832 486.269012,726.057983 463.125732,726.405945 
	C458.836121,726.470398 457.900330,725.032776 457.904999,721.002869 
	C457.981384,655.056519 457.911804,589.109924 457.883636,523.163391 
	C457.883453,522.685120 458.002258,522.206848 458.224884,520.522949 
	C471.606537,536.678345 484.438904,552.170654 497.781799,568.279236 
	C509.712036,553.431030 521.346558,538.950928 533.189392,524.179260 
z"
          />
          <path
            fill="#05D3B4"
            opacity="1.000000"
            stroke="none"
            d="
M685.702148,823.000000 
	C685.702026,837.226746 685.702026,850.953552 685.702026,865.367859 
	C673.287476,861.405701 661.864441,857.944458 650.580566,854.077026 
	C645.329712,852.277405 640.554749,852.009583 635.162720,853.936584 
	C623.765015,858.009888 612.118530,861.386902 600.136841,865.188232 
	C599.802490,863.643494 599.378662,862.587708 599.374512,861.530273 
	C599.319885,847.537842 599.417542,833.544006 599.252075,819.553223 
	C599.207520,815.786072 600.579590,814.665466 604.243469,814.773560 
	C612.399231,815.013977 620.581482,815.166138 628.723450,814.760925 
	C633.647034,814.515991 635.496643,816.142456 634.862976,820.940613 
	C634.669678,822.404236 634.833008,823.914917 634.833008,825.884033 
	C639.918518,825.884033 644.782166,825.884033 650.066711,825.884033 
	C650.066711,820.763306 650.066711,815.543396 650.066711,809.760681 
	C648.319275,809.676270 646.558777,809.520020 644.798035,809.517578 
	C631.304688,809.498901 617.809387,809.382141 604.319214,809.590576 
	C600.291992,809.652832 599.205444,808.227417 599.237549,804.363159 
	C599.402466,784.540894 599.424377,764.715881 599.252441,744.893921 
	C599.219055,741.044922 600.140686,739.673645 604.213562,739.708679 
	C626.034424,739.896667 647.857849,739.785522 669.680237,739.820923 
	C680.392944,739.838318 685.649109,745.083618 685.702393,755.704590 
	C685.730835,761.368408 685.889954,767.041260 685.591064,772.688965 
	C685.527405,773.892456 683.756470,775.983276 682.732971,776.007385 
	C672.266418,776.254211 661.791748,776.158569 650.852356,776.158569 
	C650.616028,773.295959 650.404053,770.727783 650.167969,767.868286 
	C645.208130,767.868286 640.447449,767.868286 635.247192,767.868286 
	C635.247192,772.040588 635.247192,776.249329 635.247192,781.029480 
	C636.988586,781.125916 638.745239,781.305176 640.502136,781.307495 
	C653.995422,781.325317 667.490417,781.421936 680.981018,781.228760 
	C684.668518,781.175964 685.889160,782.205811 685.812866,786.019348 
	C685.569580,798.175415 685.710022,810.339172 685.702148,823.000000 
z"
          />
          <path
            fill="#05D3B4"
            opacity="1.000000"
            stroke="none"
            d="
M316.082977,772.000000 
	C316.082611,762.500916 316.202942,753.499329 316.018585,744.504028 
	C315.950958,741.205200 316.658783,739.727417 320.369873,739.751770 
	C342.699982,739.898682 365.032013,739.744263 387.362274,739.875610 
	C397.072083,739.932678 402.479584,745.526672 402.619354,755.167847 
	C402.699036,760.666138 402.521912,766.170044 402.687134,771.664612 
	C402.789246,775.060669 401.695038,776.369080 398.072327,776.235657 
	C390.416687,775.953918 382.743683,776.139832 375.077820,776.138123 
	C367.496796,776.136475 367.496796,776.138733 366.877655,767.601379 
	C362.417297,767.601379 357.833649,767.449707 353.280731,767.755493 
	C352.549286,767.804688 351.449463,769.873291 351.395264,771.048767 
	C351.251068,774.176819 351.584717,777.326904 351.750519,780.952515 
	C353.337585,781.078064 354.748505,781.283997 356.159821,781.286865 
	C370.158173,781.315491 384.157410,781.390991 398.154510,781.257507 
	C401.587738,781.224792 402.772247,782.244385 402.749268,785.832031 
	C402.591309,810.495056 402.655121,835.159485 402.627747,859.823425 
	C402.621765,865.208496 402.328461,865.413696 397.285126,863.797485 
	C386.347168,860.292297 375.478088,856.549500 364.442627,853.385803 
	C361.327789,852.492737 357.517059,852.514526 354.398621,853.412476 
	C341.971252,856.990967 329.691101,861.080933 316.684875,865.193909 
	C316.424835,863.218933 316.087219,861.832886 316.083771,860.446045 
	C316.050201,846.947571 316.201599,833.446899 315.998901,819.951477 
	C315.939423,815.989502 317.215668,814.677673 321.147034,814.792603 
	C329.305939,815.031189 337.485077,815.095642 345.638885,814.785461 
	C350.082916,814.616394 352.347382,815.685120 351.589203,820.548889 
	C351.337250,822.164917 351.549438,823.853333 351.549438,825.944580 
	C356.755707,825.944580 361.622803,825.944580 366.835999,825.944580 
	C366.835999,820.606934 366.835999,815.386169 366.835999,809.505371 
	C363.422638,809.505371 360.311157,809.507385 357.199707,809.504944 
	C345.367615,809.495667 333.532166,809.320679 321.705200,809.561951 
	C317.430298,809.649170 315.805939,808.560852 315.951233,803.993347 
	C316.284912,793.504761 316.073242,782.998840 316.082977,772.000000 
z"
          />
          <path
            fill="#03D3B4"
            opacity="1.000000"
            stroke="none"
            d="
M521.003052,739.998413 
	C539.652405,740.001038 557.802734,739.957703 575.952698,740.024719 
	C585.878357,740.061340 591.024902,745.201111 591.121338,755.004761 
	C591.194946,762.497375 591.444275,770.004578 591.055054,777.476135 
	C590.925293,779.969055 589.550781,782.795410 587.883728,784.725098 
	C584.644775,788.474487 580.796265,791.697327 576.790161,795.530701 
	C580.926453,799.562561 584.932434,803.246155 588.641785,807.207458 
	C589.880310,808.530151 591.059753,810.555237 591.078857,812.272400 
	C591.265869,829.088074 591.206909,845.906616 591.189453,862.724304 
	C591.188782,863.355530 590.898132,863.986511 590.591125,865.232239 
	C582.096802,862.536255 573.473633,860.550537 565.490417,857.089050 
	C553.627075,851.945251 542.442932,851.949280 530.602112,857.203857 
	C522.778381,860.675781 514.258057,862.577942 505.439270,865.376587 
	C505.439270,823.537598 505.439270,782.224121 505.439270,739.998413 
	C510.343994,739.998413 515.423950,739.998413 521.003052,739.998413 
M555.635193,825.836121 
	C555.812744,821.401611 556.218323,816.956177 556.007629,812.540161 
	C555.954895,811.435364 554.007629,809.630981 552.780701,809.493896 
	C539.978821,808.063660 539.970581,808.139771 540.045532,820.977112 
	C540.049377,821.638611 540.088257,822.304016 540.032837,822.960999 
	C539.820801,825.473938 540.892761,826.626648 543.470398,826.530457 
	C547.264709,826.388916 551.064026,826.380432 555.635193,825.836121 
M548.334961,781.527649 
	C550.762634,781.393494 553.190308,781.259338 555.692871,781.121033 
	C555.692871,776.448792 555.692871,772.261536 555.692871,768.137878 
	C550.383057,768.137878 545.515686,768.137878 540.724609,768.137878 
	C538.658691,780.828003 539.023132,781.526367 548.334961,781.527649 
z"
          />
          <path
            fill="#04D3B4"
            opacity="1.000000"
            stroke="none"
            d="
M496.904755,857.836426 
	C496.905029,860.277893 496.905029,862.244202 496.905029,865.046204 
	C494.623322,864.476562 492.922974,864.147949 491.283691,863.627319 
	C480.176056,860.098938 469.118164,856.406616 457.952850,853.073181 
	C455.572968,852.362671 452.631531,852.281311 450.266205,852.981750 
	C437.364960,856.802551 424.562897,860.958252 411.103516,865.194946 
	C410.801880,863.443481 410.306976,861.911133 410.308044,860.379150 
	C410.332367,825.729919 410.494568,791.080444 410.429321,756.431519 
	C410.409332,745.809326 415.781891,739.912231 426.399139,739.832886 
	C431.231598,739.796814 436.079712,740.043030 440.892273,739.727295 
	C444.957794,739.460449 445.900909,741.013550 445.875397,744.896973 
	C445.709229,770.225769 445.895752,795.557129 445.692200,820.885376 
	C445.656982,825.265625 446.772827,826.946350 451.257202,826.439575 
	C454.515381,826.071350 457.848633,826.367615 461.841064,826.367615 
	C461.841064,823.924011 461.841064,821.982666 461.841125,820.041382 
	C461.841949,795.044739 461.935394,770.047424 461.752686,745.052124 
	C461.722198,740.878784 462.898560,739.458435 467.085815,739.746399 
	C472.061615,740.088623 477.081177,739.731140 482.077698,739.849304 
	C491.593323,740.074280 496.849182,745.400269 496.860931,754.875305 
	C496.903259,789.037292 496.894165,823.199341 496.904755,857.836426 
z"
          />
          <path
            fill="#F2FDFB"
            opacity="1.000000"
            stroke="none"
            d="
M555.248169,826.075684 
	C551.064026,826.380432 547.264709,826.388916 543.470398,826.530457 
	C540.892761,826.626648 539.820801,825.473938 540.032837,822.960999 
	C540.088257,822.304016 540.049377,821.638611 540.045532,820.977112 
	C539.970581,808.139771 539.978821,808.063660 552.780701,809.493896 
	C554.007629,809.630981 555.954895,811.435364 556.007629,812.540161 
	C556.218323,816.956177 555.812744,821.401611 555.248169,826.075684 
z"
          />
          <path
            fill="#F4FDFC"
            opacity="1.000000"
            stroke="none"
            d="
M547.883667,781.526245 
	C539.023132,781.526367 538.658691,780.828003 540.724609,768.137878 
	C545.515686,768.137878 550.383057,768.137878 555.692871,768.137878 
	C555.692871,772.261536 555.692871,776.448792 555.692871,781.121033 
	C553.190308,781.259338 550.762634,781.393494 547.883667,781.526245 
z"
          />{' '}
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
